export const environment = {
    production: false,
    debug: false,
    local: false,
    showThemeSelector: true,
    apiUrl: ['https://api.byod.farmadvisor-dev.com', 'http://localhost:8090'],
    mapbox: {
        accessToken: 'pk.eyJ1IjoidmRlcmJlbmV2IiwiYSI6ImNscmV6cXVrMDFxaDkybHNyN3dqMmY4Z3kifQ.Is0apjlBdnvGKuYJ2LkfYA',
    },
    auth: {
        domain: 'farmadvisor.us.auth0.com',
        clientId: 'j51t2do2e99ychIChlKKGldy69B1jBAH',
        authorizationParams: {
            redirect_uri: `${window.location.origin}/login`,
            audience: 'https://api.farmadvisor-dev.com/',
            scope: 'openid profile email offline_access',
        },
    },
};
